/**
 * Tabblad Resultaten: per les de inzendingen van de groepjes
 * (onderdelen/ResultaatKaart.js).
 */
import React, { useState } from 'react';
import { kleur } from '../../../theme/tokens';
import { basis } from '../stijlen';
import { useLessen } from '../hooks/useLessen';
import { ResultaatKaart } from '../onderdelen/ResultaatKaart';

export function Resultaten({ api }) {
  const lessen = useLessen(api);
  const [sessieId, setSessieId] = useState(null);
  const [resultaten, setResultaten] = useState([]);

  const bekijk = async (id) => {
    setSessieId(id);
    try {
      const data = await api.haalResultaten(id);
      if (data.success) setResultaten(data.data);
    } catch (err) { console.error('Fout:', err); }
  };

  return (
    <div style={styles.splitView}>
      <div style={styles.listPanel}>
        <div style={styles.panelHeader}><h2>Resultaten per sessie</h2></div>
        {lessen.sessies.length === 0 ? <p style={styles.empty}>Nog geen sessies.</p> : (
          <ul style={styles.list}>
            {lessen.sessies.map((sessie) => {
              const stelling = lessen.stellingVan(sessie);
              const klas = lessen.klasVan(sessie);
              return (
                <li key={sessie.id} style={sessieId === sessie.id ? styles.listItemActive : styles.listItem} onClick={() => bekijk(sessie.id)}>
                  <div>
                    <div>{stelling?.icon || '📜'} {stelling?.titel || 'Onbekend'}</div>
                    <div style={styles.sessieMeta}>{klas?.naam || 'Onbekend'}</div>
                  </div>
                  {sessie.is_actief && <span style={styles.activeBadge}>Actief</span>}
                </li>
              );
            })}
          </ul>
        )}
      </div>
      <div style={styles.detailPanel}>
        {sessieId ? (
          <>
            <h2>Inzendingen ({resultaten.length})</h2>
            {resultaten.length === 0 ? (
              <p style={styles.empty}>Nog geen groepjes hebben de opdracht afgerond.</p>
            ) : (
              <div style={styles.resultatenList}>
                {resultaten.map((r) => <ResultaatKaart key={r.discussion_id} resultaat={r} />)}
              </div>
            )}
          </>
        ) : <p style={styles.empty}>Selecteer een sessie om resultaten te zien</p>}
      </div>
    </div>
  );
}

const styles = {
  ...basis,
  activeBadge: { background: kleur.accent, color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '11px' },
  resultatenList: { display: 'flex', flexDirection: 'column', gap: '16px' },
};
